import { InMemoryCache } from "apollo-cache-inmemory";
import { Alert } from "./Alert";
import ALERT_QUERY from "../graphql/AlertsQuery.gql";
import { AlertsQuery, AlertsQuery_alerts } from "../graphql/generatedTypes/AlertsQuery";

const resolvers = {
  Mutation: {
    addAlert: (_: any, { alert }: { alert: Alert }, { cache }: { cache: InMemoryCache }): AlertsQuery_alerts => {
      const previous = cache.readQuery<AlertsQuery>({ query: ALERT_QUERY });

      if (!previous) {
        throw Error("No Local Alerts and cache not initialized");
      }

      const newAlert: AlertsQuery_alerts = { ...alert, __typename: "Alert", id: Date.now().toString() };
      const data = {
        alerts: [...previous.alerts, newAlert]
      };
      cache.writeQuery<AlertsQuery>({ query: ALERT_QUERY, data });
      return newAlert;
    },

    removeAlert: (_: any, { id }: { id: string }, { cache }: { cache: InMemoryCache }): AlertsQuery_alerts[] => {
      const previous = cache.readQuery<AlertsQuery>({ query: ALERT_QUERY });

      if (!previous) {
        throw Error("No Local Alerts and cache not initialized");
      }

      const data = {
        alerts: previous.alerts.filter(alert => alert.id !== id)
      };

      cache.writeQuery<AlertsQuery>({ query: ALERT_QUERY, data });

      return data.alerts;
    }
  }
};

export default resolvers;
